import React, { useEffect } from "react";
import PageLayout from "../components/ui/PageLayout";

const PrivacyPolicyPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-gray-900 text-white min-h-screen">
      <PageLayout>
        <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold mb-8 text-center">Privacy Policy</h1>
          <div className="space-y-6">
            <h2 className="text-2xl font-semibold">1. Introduction</h2>
            <p>
              Welcome to DreamWorld. We are committed to protecting your
              privacy. This Privacy Policy explains how we collect, use, and
              disclose your information when you use our application.
            </p>

            <h2 className="text-2xl font-semibold">
              2. Information We Collect
            </h2>
            <p>We collect the following information from you:</p>
            <ul className="list-disc list-inside space-y-2">
              <li>
                <strong>Pi Network Username:</strong> We collect your Pi
                Network username to identify you within the DreamWorld
                application.
              </li>
            </ul>
            <p>
              We do not collect any other personal information, such as your
              name, email address, or phone number.
            </p>

            <h2 className="text-2xl font-semibold">
              3. How We Use Your Information
            </h2>
            <p>We use your Pi Network username to:</p>
            <ul className="list-disc list-inside space-y-2">
              <li>Create and manage your DreamWorld account.</li>
              <li>Personalize your experience within the application.</li>
              <li>Provide you with customer support.</li>
            </ul>

            <h2 className="text-2xl font-semibold">
              4. Information Sharing and Disclosure
            </h2>
            <p>
              We do not share your Pi Network username with any third parties,
              except as required by law.
            </p>

            <h2 className="text-2xl font-semibold">5. Data Security</h2>
            <p>
              We take reasonable measures to protect your information from
              unauthorized access, use, or disclosure. However, no method of
              transmission over the internet or electronic storage is 100%
              secure. Therefore, we cannot guarantee its absolute security.
            </p>

            <h2 className="text-2xl font-semibold">6. Children's Privacy</h2>
            <p>
              Our application is not intended for children under the age of 13.
              We do not knowingly collect personal information from children
              under 13. If you are a parent or guardian and believe that your
              child has provided us with personal information, please contact
              us.
            </p>

            <h2 className="text-2xl font-semibold">
              7. Changes to This Privacy Policy
            </h2>
            <p>
              We may update this Privacy Policy from time to time. We will
              notify you of any changes by posting the new Privacy Policy on
              this page.
            </p>

            <h2 className="text-2xl font-semibold">8. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please
              contact us at{" "}
              <a
                href="mailto:nikiemaadama249@gmail.com"
                className="text-blue-400 hover:underline"
              >
                nikiemaadama249@gmail.com
              </a>
              .
            </p>
          </div>
        </div>
      </PageLayout>
    </div>
  );
};

export default PrivacyPolicyPage;